import api from './interceptor';

const BASE_URL_V2 = 'api/v2/translations';

export default {
  // API Version 2
  getTranslations: (type, params) => api.get(`${BASE_URL_V2}/${type}`, { params }),
  getTranslationsLanguage: (lang) => api.get(`${BASE_URL_V2}/languages/${lang}`),
  getQuestionnaireTranslations: (params) => api.get(`${BASE_URL_V2}/questions`, { params }),
  getSpecialitiesTranslations: (params) => api.get(`${BASE_URL_V2}/specialities`, { params }),
  getTranslationsDegrees: (params) => api.get(`${BASE_URL_V2}/degrees`, { params }),
};
